import { Spin } from "antd";
import React from "react";
import "./index.scss";

interface Props {
    title: string;
    des: string;
}

const CalculationProgress = (props: Props) => {

    return (
        <div className="caculation-progress-wrapper">
            <Spin />
            <h4>
                {props.title}
            </h4>
            <small>{props.des}</small>
        </div>
    )
}

export default CalculationProgress;